<script>
    import {navigate} from "svelte-routing";
    import {_} from '../lib/i18n';
    import {cancelAutoRegInfo, keepAutoRegPassword} from "../lib/ApiRequests.svelte";

    export let params;
    let path = '';
    $: path = (params && params.path) ? params.path : '';
    let show = true;

    function changePassword() {
        navigate(`${path}/dashboard/settings`);
    }

    async function hide() {
        show = false;
        if (params.identity && params.identity.changeKeyValue instanceof Function) {
            //params.identity.changeKeyValue('is_temporary_password', false);
            //const cancelTempPasswordResponse = await cancelAutoRegInfo();
            params.identity.changeKeyValue('keep_temporary_password', true);
            const keepAutoRegPasswordResponse = await keepAutoRegPassword();
        }
    }

</script>

{#if show}
    <section class="temp-password-block system-info system-info_yellow">
        <div class="temp-password-block__title-wrapper system-info__title-wrapper">
            <div class="temp-password-block__title-icon system-info__title-icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5 7.0835V5.00016C17.5 4.07969 16.7538 3.3335 15.8333 3.3335H4.16667C3.24619 3.3335 2.5 4.07969 2.5 5.00016V9.16683C2.5 10.0873 3.24619 10.8335 4.16667 10.8335H9.0625M15.8333 11.6668V10.0002C15.8333 9.07969 15.0871 8.3335 14.1667 8.3335C13.2462 8.3335 12.5 9.07969 12.5 10.0002V11.6668M11.6667 16.6668H16.6667C17.1269 16.6668 17.5 16.2937 17.5 15.8335V12.5002C17.5 12.0399 17.1269 11.6668 16.6667 11.6668H11.6667C11.2064 11.6668 10.8333 12.0399 10.8333 12.5002V15.8335C10.8333 16.2937 11.2064 16.6668 11.6667 16.6668Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <ellipse cx="6.25" cy="7.0835" rx="1.25" ry="1.25" fill="black"></ellipse>
                    <ellipse cx="10" cy="7.0835" rx="1.25" ry="1.25" fill="black"></ellipse>
                </svg>
            </div>
            <h3 class="temp-password-block__title-text system-info__title-text">
                {$_('changeTempPasswordAlert.title')}
            </h3>
        </div>
        <p class="temp-password-block__text system-info__text">
            {$_('changeTempPasswordAlert.description')}
        </p>
        <div class="temp-password-block__controls-wrapper system-info__controls-wrapper">
            <button on:click={changePassword} class="button button_ghost system-info__controls-btn system-info__controls-btn_main temp-password-block__controls-btn">
                {$_('changeTempPasswordAlert.changePasswordBtnLabel')}
            </button>
            <button on:click={hide} class="button button_textual system-info__controls-btn system-info__controls-btn_secondary temp-password-block__controls-btn">
                {$_('changeTempPasswordAlert.keepPasswordBtnLabel')}
            </button>
        </div>
    </section>
{/if}